import { render, staticRenderFns } from "./VTab.vue?vue&type=template&id=7d3b32ed&"
import script from "./VTab.vue?vue&type=script&lang=js&"
export * from "./VTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports